import { useEffect } from 'react';
import { userStore } from '../../app/stores/User';
import { navigationStore } from '../../app/stores/Navigation';
import { Portal } from './Portal';
import { RouteProp } from '@react-navigation/native';
import { ParamListBase } from '@react-navigation/routers';
import { useScreenComponent } from '../../app/hooks/custom/useScreenComponent';
import { ScreenComponent } from '../../models/enums/ScreenComponents';

export const PortalRoutes = ({ route }: { route: RouteProp<ParamListBase, string> }) => {
    const { authenticated } = userStore(state => state.user);
    const { updateProfileDrawerOpen } = navigationStore(state => state);
    const { navigateToScreen } = useScreenComponent();

    useEffect(() => {
        if (!authenticated) {
            // If not authenticated, open profile drawer for login and redirect to shop
            updateProfileDrawerOpen(true);
            navigateToScreen(ScreenComponent.Shop);
        }
    }, [authenticated]);

    // Only render Portal if authenticated
    if (!authenticated) {
        return null;
    }

    return <Portal route={route} />;
};